<ng-container *ngIf="operation && amount">
  <!-- Increment -->
  <ng-container *ngIf="returnSign(operation) === 1">
    <div class="increment">
      <div class="triangle-up"></div>
      <p class="increment-text">{{ returnPositive(amount) }}%</p>
    </div>
  </ng-container>

  <!-- decrement -->
  <ng-container *ngIf="returnSign(operation) === -1">
    <div class="decrement">
      <div class="triangle-down"></div>
      <p class="decrement-text">{{ returnPositive(amount) }}%</p>
    </div>
  </ng-container>
  <ng-container *ngIf="operation == '-' || operation == 0">
    <div class="decrement">
      <p style="margin: 0px">- %</p>
    </div>
  </ng-container>
</ng-container>
